import React from "react";
import { makeStyles, Typography, ButtonBase, Box } from "@material-ui/core";

import { getModelName, formatPriceCents } from "../../../../product/utils";
import ProductImage from "../../../../product/ProductImage";

export default function ProductListItemFunnel({ product, onDelete }) {
  const classes = useStyle();
  const modelName = getModelName(product);
  return (
    <div className={classes.container}>
      <ProductImage
        src={product.picture_new || product.pictures[0].url}
        addBrightness={!product.picture_new}
        alt={modelName}
        product={product}
        width="20%"
        maxWidth={200}
      />
      <Box className={classes.grid} pl={4}>
        <Typography variant="body2" className={classes.name}>
          {product.isSold
            ? `Oups! Ce produit ${product.product_type} ${product.brand} ${product.model_reference} vient d'être acheté par un autre client`
            : modelName}
        </Typography>
        {!product.isSold && <Typography>{formatPriceCents(product.price)}</Typography>}
        <ButtonBase onClick={() => onDelete(product)} className={classes.deleteButton}>
          <Typography variant="body2">Supprimer</Typography>
        </ButtonBase>
      </Box>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "flex-start",
    paddingBottom: theme.spacing(4),
    borderBottom: "1px solid #DBDFE8",
  },
  grid: {
    justifyItems: "start",
    display: "grid",
    gridRowGap: theme.spacing(2),
    width: "80%",
  },
  deleteButton: {
    color: "#8795B3",
  },
  placeholder: {
    width: "20%",
    paddingBottom: "20%",
    backgroundColor: "white",
    marginRight: theme.spacing(2),
  },
}));
